const labels = {
  name: 'Full name', email: 'Work email', company: 'Organisation name',
  organisation_type: 'Organisation type', organisation_size: 'Organisation size',
  interests: 'Programme interests', budget: 'Estimated budget',
  start_date: 'Preferred start date', message: 'Additional details',
};

export const contactErrorMessage = (error) => {
  const detail = error.response?.data?.detail;
  if (error.response?.status === 422 && Array.isArray(detail)) {
    return detail.map((issue) => {
      const field = issue.loc?.[1];
      if (field === 'email') return 'Work email: please enter a valid email address.';
      return `${labels[field] || 'Enquiry'}: ${issue.msg || 'please check this field.'}`;
    }).join(' ');
  }
  return 'Failed to submit form. Please try again.';
};